import Clients from "components/clients/clients";
import Contact from "components/contact/contact";
import Footer from "components/footer/footer";
import Navbar from "components/navbar";
import ChooseUs from "ui/home/choose-us";
import Hero from "ui/home/hero";
import Services from "ui/home/services";

const HomePage = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <Services />
      <ChooseUs />
      <Clients />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
